import { ICompletedFields } from '.'

interface IValidation {
  fieldsToComplete: string[]
  completedFields: ICompletedFields
}
export const checkIfValid = ({
  fieldsToComplete,
  completedFields
}: IValidation) =>
  fieldsToComplete.some(
    value => !completedFields[value as keyof ICompletedFields]
  )

export const deleteObjectEmptyPositions = (object: {}) => {
  Object.keys(object).forEach(key => {
    if (!object[key as keyof {}]) delete object[key as keyof {}]
  })
  return object
}

export const titleCase = (string: string | null) => {
  console.log(string)
  if (!string) return ''
  return string[0].toUpperCase() + string.slice(1).toLowerCase()
}
